import React from 'react';
import i18n from '../../i18n';
import { Translation } from 'react-i18next';
import Header from '../../cmps/Header';
import { genKey } from '../../utils/utils';
import Content from '../../cmps/Content';
import Config from '../../config.json';
import { CardsActive } from '../../cmps/EmployeeCards/CardsActive';
import { CardOrder } from '../../cmps/EmployeeCards/CardOrder';

class EmployeeChange extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            lng: i18n.language,

            laptopDevices: [],
            token: this.props.match.params.token
        }

        this.onRadioValueChangeLaptop = this.onRadioValueChangeLaptop.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        if (!this.isGuid(this.props.match.params.token)) {
            this.props.history.push('/Error')
        }

        this.getNotebooks();
        this.getEmployee();
    }
    onRadioValueChangeLaptop(event) {
        this.setState({
            selectedLaptop: parseInt(event.currentTarget.value)
        });
    }

    mapDevices(type, devices, callback, stateName) {
        const lng = this.state.lng;
        let confDelimiter = ";";
        if (type === "headsets" || type === "keyboards") {
            confDelimiter = ",";
        }
        let elements;
        if (devices) {

            elements = devices.map(item => {
                let bullets = lng === "de" ? item.Konfiguration.split(confDelimiter) : item.KonfigurationEn.split(confDelimiter);
                bullets = bullets.map(i => {
                    return i.replace("+", "").trim();
                });

                return {
                    id: item.Id,
                    key: type + "_" + item.Id,
                    name: item.Title,
                    description: lng === "de" ? item.Beschreibung : item.BeschreibungEn,
                    image: this.imageDecode(item.Templatebild),
                    bullets: bullets,
                    callback: callback,
                    active: this.state[stateName] === item.Id
                };

            });
        }

        return elements;
    }

    getDevicesBulletsMax(type, devices) {
        const lng = this.state.lng;
        let confDelimiter = ";";
        if (type === "headsets" || type === "keyboards") {
            confDelimiter = ",";
        }
        let bulletsMax = 0;
        for (let item of devices) {
            let bullets = lng === "de" ? item.Konfiguration.split(confDelimiter) : item.KonfigurationEn.split(confDelimiter);
            bullets = bullets.map(i => {
                return i.replace("+", "").trim();
            });
            const bulletsCount = bullets.reduce((sum, i) => {
                //console.log("sum: " + sum);
                //console.log("i: "  + i);
                const liHeight = i.length > 33 ? 40 : 20;
                sum = sum + liHeight;
                return sum;
            }, 0);
            if (bulletsCount > bulletsMax) {
                bulletsMax = bulletsCount;
            }
        }

        return bulletsMax;
    }

    getNotebooks() {
        var notebooksURL = Config.REACT_APP_BACKEND_URL + "/notebooks?token=" + this.props.match.params.token + "&change=true"
        fetch(notebooksURL)
            .then(res => res.json())
            .then(
                (res) => {
                    this.setState({
                        isLoaded: true,
                        laptopDevices: res
                    });
                },
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    imageDecode(imgData) {
        var urlImg = JSON.parse(imgData);
        return Config.REACT_APP_BACKEND_URL + "/image?path=" + urlImg.serverRelativeUrl;
    }

    getEmployee() {
        fetch(Config.REACT_APP_BACKEND_URL + "/employeechange?token=" + this.props.match.params.token, {
            headers: {
                accept: "application/json;odata=verbose"
            }
        })
            .then(res => res.json())
            .then(result => {
                this.setState({
                    employee: result,
                    //shipping: result.Shipping != null ? result.Shipping : false
                }, () => {
                    //console.log('employee:', this.state.employee);
                    if (this.state.employee && this.state.employee.Status === "Abgeschlossen") {
                        this.props.history.push('/EmployeeChangeMicrosite/' + this.props.match.params.token + '');
                    }
                });
            },
                error => {
                    this.setState({
                        isLoaded: true
                    });
                }
            )
    }

    handleSubmit(event) {
        event.preventDefault();

        //const address = this.state.street + ", " + this.state.zip + " " + this.state.city + ", " + this.state.country;

        //const cleanAddress = DOMPurify.sanitize(address);
        //console.log('state', this.state)
        var data = {
            LaptopId: this.state.selectedLaptop,
            Token: this.state.token
        }
        //console.log('data', JSON.stringify(data), data);
        fetch(Config.REACT_APP_BACKEND_URL + "/employeechange", { //Create new endpoint for changelaptop
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        })
        .then(() => {
            this.props.history.push('/EmployeeChangeMicrosite/' + this.props.match.params.token + '')
        })
    }
    getFirstName(fullname) {
        if (/\s/.test(fullname)) {
            var nameParts = fullname.split(',');

            if (nameParts.length === 2) {
                return nameParts[1].toUpperCase();
            }
            else {
                return nameParts[0].toUpperCase();
            }
        }
        else {
            return fullname.toUpperCase();
        }
    }
    isGuid(value) {
        const guidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/;
        return guidRegex.test(value);
    }

    render() {
        const { laptopDevices } = this.state;
        const isMobile = document.documentElement.clientWidth < 800 ? true : false;
        const enable = this.state.selectedLaptop;
        const headerContent = (
            <div>
                {
                    isMobile ?
                        <div>
                            <h2 style={{ fontFamily: 'AvertaPE-Extrabold' }}><Translation>{t => t("description.employeeChangeWelcomeText").toUpperCase()}</Translation><br /> {this.state.isLoaded ? " " + this.getFirstName(this.state.employee?.Mitarbeiter) : ""}!</h2>
                        </div>
                        :
                        <div>
                            <h1 style={{ fontFamily: 'AvertaPE-Extrabold' }}><Translation>{t => t("description.employeeChangeWelcomeText").toUpperCase()}</Translation><br /> {this.state.isLoaded ? " " + this.getFirstName(this.state.employee?.Mitarbeiter) : ""}!</h1>
                        </div>
                }
            </div>
        );
        
        const content = [
            //<CardHello heading="description.employeeChangeWelcomeText" description={["description.employeeWelcomeText6", ""]} key={genKey("cardhello")} />,
            <CardsActive elements={this.mapDevices("laptops", laptopDevices, this.onRadioValueChangeLaptop, "selectedLaptop")} heading="description.laptop" showInfos={true} key={genKey("cards")} cardsPerRow={3} bulletsMax={this.getDevicesBulletsMax("laptops", laptopDevices)} lng={this.state.lng} />,
            <CardOrder heading="description.orderFooter.heading" enabled={enable} key={genKey("cardorder")} />
        ];
        return (
            <>
                <form onSubmit={this.handleSubmit}>
                    <Header headerContent={headerContent} />
                    <Content content={content} lng={this.state.lng} />
                </form>
            </>
        )
    }


}

export default EmployeeChange;